import PropTypes from 'prop-types';
import { action, extendObservable, reaction } from 'mobx';
import FlagStore from '../FlagStore';
import InputStore from '../InputStore';
import FuseSelectStore from '../FuseSelectStore';
import { emailValidator } from '../../email';

export const ROLE_FULL_ACCESS = { value: 'ROLE_CUSTOMER_ADMIN', label: 'Full Access' };
export const ROLE_SUPERDUPER = { value: 'ROLE_ADMIN', label: 'Superduper Admin' };
export const ROLE_CONSOLE = { value: 'ROLE_CONSOLE_ADMIN', label: 'Console Admin' };
export const ROLE_READ_ONLY = { value: 'ROLE_READ_ONLY_CONSOLE_USER', label: 'Read-Only Access' };
export const ALL_ROLES = [ROLE_FULL_ACCESS, ROLE_SUPERDUPER, ROLE_CONSOLE, ROLE_READ_ONLY];

export const fetchDisplayRoleName = (roleValue) => {
    const role = ALL_ROLES.find((checkedRole) => checkedRole.value === roleValue);
    return role ? role.label : '';
};

export const ModalMode = {
    EDIT: 'edit',
    VIEW: 'view',
    CREATE: 'add',
    DELETE: 'delete',
};

export default class AdministratorModalStore {
    static PropType = PropTypes.shape({
        email: InputStore.PropType.isRequired,
        firstName: InputStore.PropType.isRequired,
        lastName: InputStore.PropType.isRequired,
        roleSelect: FuseSelectStore.PropType.isRequired,
        sendInvitation: FlagStore.PropType.isRequired,

        modal: FlagStore.PropType.isRequired,
        mode: PropTypes.string,
        deleteConfirmation: FlagStore.PropType.isRequired,

        canEdit: PropTypes.bool.isRequired,

        setValue: PropTypes.func.isRequired,
        getValue: PropTypes.func.isRequired,
        hasChanged: PropTypes.func.isRequired,
    });

    constructor(data = { possibleRoles: ALL_ROLES }) {
        extendObservable(this, /** @class AdministratorModalStore */{
            email: new InputStore(),
            firstName: new InputStore(),
            lastName: new InputStore(),
            roleSelect: new FuseSelectStore({ options: data.possibleRoles }),

            originalValue: {},

            modal: new FlagStore(),
            mode: null,
            sendInvitation: new FlagStore(true),
            deleteConfirmation: new FlagStore(),

            canEdit: false,
        }, data);

        this.email.setValidator((email) => emailValidator(email));

        reaction(() => this.modal.isOpen, (value) => {
            if (!value) {
                this.setMode(null);
            }
        });
    }

    setMode = action((mode) => {
        this.mode = mode;
    });

    setValue = action((value) => {
        value = { role: this.roleSelect.options[0].value, ...value };
        this.originalValue = value;
        this.email.setValue(value.email);
        this.firstName.setValue(value.firstName);
        this.lastName.setValue(value.lastName);
        this.roleSelect.setSelectedValues([value.role]);
        this.sendInvitation.setTrue();
        this.deleteConfirmation.setFalse();
        this.canEdit = !value.isPrimary;
    });

    getValue = () => ({
        id: this.originalValue.id,
        email: this.email.value,
        firstName: this.firstName.value,
        lastName: this.lastName.value,
        role: this.roleSelect.selectedValues[0],
        sendInvitation: this.sendInvitation.value,
    });

    hasChanged = () => !this.email.equals(this.originalValue.email || '') ||
        !this.firstName.equals(this.originalValue.firstName || '') ||
        !this.lastName.equals(this.originalValue.lastName || '') ||
        this.roleSelect.selectedValues[0] !== this.originalValue.role;
}
